import { createSlice } from "@reduxjs/toolkit";

const globalStore = createSlice({
  name: "global",
  initialState: {
    adminProfile: null,
    vendorProfile: null,
    vendorManagerProfile: null,
    corporateAdminProfile: null,
    towerHeadAdminProfile: null,
    userProfile: null,
    siteSetting: null,
  },
  reducers: {
    setAdminProfile: (state, action) => {
      state.adminProfile = action.payload;
    },
    resetAdminProfile: (state) => {
      state.adminProfile = null;
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload;
    },
    resetUserProfile: (state) => {
      state.userProfile = null;
    },
    setSiteSetting: (state, action) => {
      state.siteSetting = action.payload;
    },
    resetSiteSetting: (state) => {
      state.siteSetting = null;
    },

    setVendorProfile: (state, action) => {
      state.vendorProfile = action.payload;
    },
    resetVendorProfile: (state) => {
      state.vendorProfile = null;
    },
    
    setVendorManagerProfile: (state, action) => {
      state.vendorManagerProfile = action.payload;
    },
    resetVendorManagerProfile: (state) => {
      state.vendorManagerProfile = null;
    },
    
    setcorporateAdminProfile: (state, action) => {
      state.corporateAdminProfile = action.payload;
    },
    resetcorporateAdminProfile: (state) => {
      state.corporateAdminProfile = null;
    },
    settowerHeadAdminProfile: (state, action) => {
      state.towerHeadAdminProfile = action.payload;
    },
    resettowerHeadAdminProfile: (state) => {
      state.towerHeadAdminProfile = null;
    },
  },
});

export const {
  setAdminProfile,
  resetAdminProfile,
  setSiteSetting,
  setUserProfile,
  resetSiteSetting,
  resetUserProfile,
  setVendorProfile,
  resetVendorProfile,
  setVendorManagerProfile,
  resetVendorManagerProfile,
  setcorporateAdminProfile,
  resetcorporateAdminProfile,
  settowerHeadAdminProfile,
  resettowerHeadAdminProfile
} = globalStore.actions;
export default globalStore.reducer;
